import { render, staticRenderFns } from "./RSPExtendTimeItem.vue?vue&type=template&id=7b5f4962&scoped=true&"
import script from "./RSPExtendTimeItem.vue?vue&type=script&lang=js&"
export * from "./RSPExtendTimeItem.vue?vue&type=script&lang=js&"
import style0 from "./RSPExtendTimeItem.vue?vue&type=style&index=0&id=7b5f4962&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f4962",
  null
  
)

export default component.exports